var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gc-main-layout',{attrs:{"title":_vm.title,"isXSmall":_vm.isXSmall,"isLarge":_vm.isLarge}},[_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }